import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { filter } from 'rxjs/operators';
import { ZoningCodeService } from 'src/app/core/services';
import { IZoningCodeModel } from 'src/app/interfaces/zoning-code-model.interface';
import { LoaderService } from 'src/shared/services';
import * as _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable } from 'rxjs';
import { ImportTableWorkflowBaseComponent } from '../shared/import-table-workflow.base';

@Component({
    standalone: false,
    selector: 'app-calibration-uses-values-import-table',
    templateUrl: './calibration-uses-values-import-table.component.html',
    styleUrls: ['./calibration-uses-values-import-table.component.scss']

})
export class CalibrationUsesValuesImportTableComponent extends ImportTableWorkflowBaseComponent<IZoningCodeModel> implements OnInit {
    zoningCode: IZoningCodeModel = null;
    usesValuesValidationData$: Observable<IZoningCodeModel | null>;
    private usesValuesValidationData: IZoningCodeModel = null;
    private readonly usesValuesValidationDataSubject = new BehaviorSubject<IZoningCodeModel | null>(null);

    constructor(
        private readonly zoningCodeService: ZoningCodeService,
        loaderService: LoaderService,
        dialog: MatDialog,
        toastrService: ToastrService
    ) {
        super(loaderService, dialog, toastrService);
        this.usesValuesValidationData$ = this.usesValuesValidationDataSubject.asObservable();
    }

    ngOnInit(): void {
        this.loaderService.show();
        this.zoningCodeService.zoningCodes.pipe(filter(zc => zc !== null && zc.length > 0)).subscribe(zc => {
            this.zoningCode = zc[0];
            if (!this.zoningCode) {
                return;
            }
            this.loaderService.hide();
        });
    }

    clearUsesTable(): void {
        this.selectedFileData = null;
        this.resetValidationData();
    }

    protected getValidationData(): IZoningCodeModel {
        return this.usesValuesValidationData;
    }

    protected resetValidationData(): void {
        this.usesValuesValidationData = null;
        this.usesValuesValidationDataSubject.next(null);
    }

    protected setValidationData(result: IZoningCodeModel): void {
        this.usesValuesValidationData = null;
        this.usesValuesValidationDataSubject.next(null);
        // Needed to refresh the accordion properly.
        setTimeout(() => {
            this.usesValuesValidationData = result;
            this.usesValuesValidationDataSubject.next(result);
        }, 0);
    }

    protected getImportConfirmationMessage(): string {
        return `Current uses values will be imported to Zoning Code. Continue?`;
    }

    protected runValidationRequest(): Observable<IZoningCodeModel> {
        return this.zoningCodeService.validateZCmbUsesValues(this.zoningCode.Id, this.selectedFileData);
    }

    protected runImportRequest(): Observable<any> {
        return this.zoningCodeService.importZCmbUsesValues(this.zoningCode.Id, this.selectedFileData);
    }

    protected getErrorMessage(err: any): string {
        return _.get(err, 'error.messages', []).join('. ');
    }
}
